<!-- A tinted icon tile, never a person-like lettered avatar: AGENTS.md "Do not represent Relationships as people." -->
<script setup lang="ts">
import { computed } from 'vue'
import RelationshipIcon from '@/features/relationships/components/RelationshipIcon.vue'
import { ledgerToneFor } from '../internal/avatar.ts'

const props = defineProps<{ id: string }>()
const tone = computed(() => `var(${ledgerToneFor(props.id)})`)
</script>

<template>
  <span
    aria-hidden="true"
    class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
    :style="{ backgroundColor: `color-mix(in srgb, ${tone} 22%, var(--color-surface))`, color: tone }"
  >
    <RelationshipIcon name="ledger" />
  </span>
</template>
